import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';
import { SelectedAddress } from './Address.types';
import { normalizeDeliveryAddress } from '../../../../../../util/deliveryAddress';
import { persistDeliveryAddress } from '../../../../../../util/deliveryAddressStorage';

export const INITIAL_STATE = {
  selectedAddress: null as SelectedAddress | null,
  selectionInitialized: false,
};

const mainSlice = createSlice({
  name: 'address',
  initialState: { ...INITIAL_STATE },
  reducers: {
    setSelectedAddress(state, action) {
      const selectedAddress = normalizeDeliveryAddress(action.payload);
      if (
        state.selectionInitialized &&
        isEqual(state.selectedAddress, selectedAddress)
      )
        return state;
      persistDeliveryAddress(selectedAddress);
      return {
        ...state,
        selectedAddress,
        selectionInitialized: true,
      };
    },
    restoreSelectedAddress(state, action) {
      if (state.selectionInitialized || state.selectedAddress) return state;
      return {
        ...state,
        selectedAddress: normalizeDeliveryAddress(action.payload),
        selectionInitialized: true,
      };
    },
  },
});

export const { setSelectedAddress, restoreSelectedAddress } = mainSlice.actions;

export default mainSlice.reducer;
